import React from 'react';
import ThreeCanvas from './ThreeCanvas';
import useThreeNudgytAgentClient from '../../hooks/useThreeNudgytAgentClient';

/**
 * Owns the Nudgyt Agent client and renders the scene around it.
 *
 * The hook is mounted here, outside <Canvas>, on purpose: react-three-fiber
 * only re-renders its tree while the canvas measures larger than 0x0, so while
 * the parent app hides the avatar (display: none) a client living inside the
 * scene stops seeing context updates — the user's message would sit unsent
 * until the avatar was shown again. Everything the hook does (websocket, audio
 * playback, postMessage) is renderer-agnostic, so nothing is lost by hoisting
 * it; only the avatar's lipsync needs the scene, and that is passed back down.
 */
function ThreeNudgytAgentClient() {
  const { client } = useThreeNudgytAgentClient();

  return <ThreeCanvas client={client} />;
}

export default ThreeNudgytAgentClient;
